var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('v-container',{staticClass:"d-flex justify-center align-center",style:({ height: '100svh' })},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"65"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }